export const PROGRAMS = "programs";
export const ROAD_MAP = "road_map";
export const REVIEWS = "reviews";
export const SERVICES = "services";